<template>
  <layout>
    <div slot="content">
      <i-card title="产品分类">
        <div slot="content">
          <el-table :data="groupList" :border="true">
            <el-table-column prop="id" label="分组id"></el-table-column>
            <el-table-column prop="name" label="分组名称"></el-table-column>
            <el-table-column prop="name" label="分组类型">
              <div slot-scope="scope">
                <el-tag size="mini" type="primary">
                  {{scope.row.sys == 1 ?'系统分组':'普通分组'}}
                </el-tag>
              </div>
            </el-table-column>
            <el-table-column label="操作" width="150">
              <div slot-scope="scope">
                <el-button size="mini" type="primary" @click="postGroup(scope.row)" :disabled="scope.row.sys == 1">编辑</el-button>
                <el-button size="mini" type="danger" @click="delGroup(scope.row.id)" :disabled="scope.row.sys == 1">删除</el-button>
              </div>
            </el-table-column>
          </el-table>
        </div>
        <div slot="right-menu">
          <el-button type="success" size="medium" icon="el-icon-plus" @click="postGroup()">添加用户组
          </el-button>
        </div>
      </i-card>
    </div>
  </layout>
</template>

<script>
  export default {
    name: "cate",
    data() {
      return {
        groupList: [],
      }
    },
    methods: {
      getGroupList: function () {
        this.$http.request('groupList').then(res => {
          this.groupList = res.data;
        });
      },
      delGroup: function (groupId) {
        this.$confirm('是否删除该用户组？删除后不恢复', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.request('delGroup', {id: groupId}).then((res) => {
            let _self = this;
            if (res.status === 'success') {
              this.$message({
                type: 'success',
                message: res.message,
                onClose: function () {
                  _self.getGroupList();
                }
              });
            }
          });
        })
      },
      postGroup: function (group) {
        let notice = '';
        if (group) {
          notice = '您正在编辑用户组:' + group.name;
        } else {
          notice = '请输入用户组名称';
          group = {};
        }
        this.$prompt(notice, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({value}) => {
          group.name = value;
          this.$http.request('postGroup', group).then(res => {
            if (res.status === 'success') {
              this.getGroupList();
              this.$message({message: res.message, type: 'success'});
            }
          })
        })
      },
    },
    created: function () {
      this.getGroupList();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/user/group.vue